<template>
  <div>
    <page-header>
      <template #title>
        <h1 class="page-title">All Claims</h1>
      </template>
    </page-header>
    <div class="row">
      <div class="col-12">
        <div class="card mb-3">
          <div class="table-responsive">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Claim Reference</th>
                  <th>Stage</th>
                  <th>Client Name</th>
                  <th>Client Vehicle Registration</th>
                  <th>Third Party</th>
                  <th>Third Party Insurer</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="index" v-for="(result, index) in results">
                  <td>
                    {{ result.source?.claim_reference || 'Not Available' }}
                  </td>
                  <td>
                    {{ stageLabel(result) || 'Not Available' }}
                  </td>
                  <td>
                    {{ result.client?.full_name || 'Not Available' }}
                  </td>
                  <td>
                    {{
                      result.client?.vehicle?.registration || 'Not Available'
                    }}
                  </td>
                  <td>
                    {{ result.third_parties[0]?.full_name || 'Not Available' }}
                  </td>
                  <td>
                    {{
                      result.third_parties[0]?.insurer?.name || 'Not Available'
                    }}
                  </td>
                  <td>
                    <button
                      class="btn btn-primary"
                      v-on:click.prevent="view(result)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer text-right" v-show="showPagination">
            <pagination
              :data="pagination_data"
              v-on:updateResults="getData"
            ></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './Modules/Shared/PageHeader.vue';

export default {
  components: {
    PageHeader
  },

  data() {
    return {
      results: [],
      pagination_data: {}
    };
  },

  computed: {
    showPagination() {
      return (
        this.pagination_data.next_page_url || this.pagination_data.prev_page_url
      );
    }
  },

  mounted() {
    this.search();
    this.getData();
  },

  methods: {
    search() {
      window.Ajax.get(`/incidents?per_page=${this.perPage}`)
        .then(response => {
          let results = response.data;
          if (results.data.length) {
            this.results = results.data;
            this.pagination_data = results;
          }
        })
        .catch(error => {
          this.indicator = false;
        });
    },

    getData(url) {
      if (!url) {
        url = `/incidents?per_page=${this.perPage}`;
      }
      window.Ajax.get(url)
        .then(response => {
          this.results = response.data.data;
          this.pagination_data = response.data;
        })
        .catch(error => {});
    },

    view(result) {
      let module = result.stage.name;

      if (module === 'hire_monitoring') {
        module = 'claim_monitoring';
      }

      let segment = module.replace(/_/g, '-');

      this.$router.push(`/${segment}/${result.identifier}`);
    },

    stageLabel(result) {
      if (result.stage?.name === 'hire_monitoring') {
        return 'Claim Monitoring';
      }

      return result.stage?.label;
    }
  }
};
</script>
